import * as React from 'react';
import { Popover as Popovers, PopoverActionsBar } from '@progress/kendo-react-tooltip';
import { Button } from '@progress/kendo-react-buttons';
import { CustomMultiSelect } from '@/components/common/CustomMultiSelect';
import { shallow } from 'zustand/shallow';
import { useMasterApiStore } from '@/store/MasterDataStore';
import {
  checkBrokerTypeWithSpace,
  filterDataByHighestPriority,
  formatBrokerTypes,
  formatRelativeTime,
  rednderLegStatusIcon,
} from '@/helpers';
import CustomTooltip from '@/components/common/CustomTooltip';
import { useSubStatusStore } from '@/store/SubStatusStore';
import { SUB_STATUS_ID } from '@/helpers/constants';
import { getSubStatusIcon } from '@/helpers/subStatusDisplay';
import { applySubStatusChange, buildSubStatusOptions } from './subStatusRules';

const SubStatus = (props) => {
  const { data, index, showRowSubStatus, setShowRowSubStatus, handleAssignSchedulerSubStatus } = props;
  const anchor = React.useRef(null);
  const multiselectRef = React.useRef();
  const [ filteredObjects, setFilteredObjects ] = React.useState([]);
  const { subStatusData, setSubStatusData } = useSubStatusStore();

  const filterData = (data, ids) => {
    return data?.filter((item) => ids?.includes(item.id?.toString()));
  };
  const { getAllSchedulerSubStatusMasterData } = useMasterApiStore(
    (state) => ({
      getAllSchedulerSubStatusMasterData: state.getAllSchedulerSubStatusMasterData,
    }),
    shallow
  );
  const subStatusOptions = React.useMemo(
    () => buildSubStatusOptions(getAllSchedulerSubStatusMasterData?.data?.responseData),
    [ getAllSchedulerSubStatusMasterData ]
  );

  const onOpenPopUp = () => {
    setSubStatusData({ subStatus: filteredObjects, data });
    setShowRowSubStatus(index);
  };

  React.useEffect(() => {
    if(getAllSchedulerSubStatusMasterData?.data?.responseData) {
      const InitialFilterData = filterData(getAllSchedulerSubStatusMasterData?.data?.responseData, data?.phoLegsSchedulerSubStatus)?.filter((f) => f?.id !== SUB_STATUS_ID.NEW);
      setFilteredObjects(InitialFilterData);
    }
  }, [ getAllSchedulerSubStatusMasterData, data ]);

  const maxPriorityObject = React.useMemo(() => {
    const InitialFilterData = filterData(getAllSchedulerSubStatusMasterData?.data?.responseData, data?.phoLegsSchedulerSubStatus)?.filter((f) => f?.id !== SUB_STATUS_ID.NEW);
    const filteredPriorityDataBasedOnPriority = InitialFilterData?.map((f) => f.priority);
    const highestpriority = filterDataByHighestPriority(getAllSchedulerSubStatusMasterData?.data?.responseData, filteredPriorityDataBasedOnPriority?.toString());
    return highestpriority?.[0];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ data?.phoLegsSchedulerSubStatus ]);

  const handleEvent = (event) =>
    applySubStatusChange(filteredObjects, event, subStatusOptions);

  const handleSelectionChange = (_, event) => {
    const newFilteredObjects = handleEvent(event);
    setFilteredObjects(newFilteredObjects);
    setSubStatusData({ subStatus: newFilteredObjects, data });
    multiselectRef?.current?.setValue([ ...newFilteredObjects ]);
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const popoverInner = document.querySelector('.k-popover-inner');
      const childAnimationContainer = document.querySelector('.k-multiselecttree-popup');
      const layout = childAnimationContainer?.getBoundingClientRect();
      if (childAnimationContainer && layout.top < event.y && layout.bottom > event.y && layout.left < event.x && layout.right > event.x) {
        return;
      }
      if (popoverInner && !popoverInner.contains(event.target)) {
        setShowRowSubStatus(-1);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ subStatusData ]);

  return (
    <div style={{ position:'relative' }} >
      <div onClick={onOpenPopUp} className="d-flex cursor-pointer align-items-center main-status-box"    >
        <div className="main-status-icon">{rednderLegStatusIcon(data.schedulerStatus)}</div>
        <p className="mb-0 text" style={{ padding:2 }}>{data.schedulerStatus}</p>
        <CustomTooltip
          placement="top"
          hide={true}
          description={
            <span>
              <p className="mb-0 text-dark-grey">
                {' '}
                <strong>{maxPriorityObject?.status} </strong>
                <span className="text-light-grey">
                  ({formatRelativeTime(data?.subStatusLastUpdated)}{' '}
                  {data?.subStatusLastUpdatedBy && data?.subStatusLastUpdatedBy !== 'System'
                    ? `by ${data?.subStatusLastUpdatedBy}`
                    : formatBrokerTypes(checkBrokerTypeWithSpace(data.brokerName))}
                  )
                </span>
              </p>{' '}
            </span>
          }
        >
          <span className="sub-status cursor-pointer relative-icon-minus">
            {getSubStatusIcon(maxPriorityObject?.id) && (
              <img src={getSubStatusIcon(maxPriorityObject?.id)} alt="" height="21" />
            )}
          </span>
        </CustomTooltip>
      </div>
      <Button className="hideBtn"  ref={anchor}>  </Button>
      <Popovers className="custom-popover custom-popovers" show={showRowSubStatus === index} anchor={anchor.current && anchor.current.element} position="top" >
        <div className="popover-body  custom-status-popover">
          <CustomMultiSelect
            ref={multiselectRef}
            dataList={subStatusOptions}
            value={Array.isArray(filteredObjects) ? filteredObjects?.filter((f) => f?.id !== SUB_STATUS_ID.NEW) : []}
            handleFilterName={handleSelectionChange}
            keyName="status"
            name="schedulerSubStatus"
            textField="status"
            dataItemKey="id"
            upDown={true}
            label={
              data.phoLegsSchedulerSubStatus ? (
                <p className="fs-12 mb-0 text-light-grey"> Sub - Status</p>
              ) : (
                'Sub-Status'
              )
            }
          />
        </div>
        <PopoverActionsBar>
          <div className="model-footer-action text-end pt-1">
            <Button
              className="height-42 border-0 fs-14 font-700"
              style={{ marginRight: '10px' }}
              themeColor="primary"
              fillMode="outline"
              onClick={() => {
                setShowRowSubStatus(-1);
              }}
            >
              Cancel
            </Button>

            <Button className="height-42 fs-14" themeColor="primary" onClick={() => {
              handleAssignSchedulerSubStatus('schedulerSubStatus', filteredObjects, data?.legId, data);
              setShowRowSubStatus(-1);
            }}>
              Save Changes
            </Button>
          </div>
        </PopoverActionsBar>
      </Popovers>
    </div>
  );
};
export default React.memo(SubStatus);
